module.exports = __webpack_public_path__ + "img/star_on.b4f7c176.svg";